var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.854,
    height: 89.529,
    viewBox: "0 0 67.854 89.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7a7a7a;opacity:0.05;}.b{fill:#e0e0e0;}.c{fill:#E9F1F8;}.d{fill:#C1CEDA;}.e{fill:#b6b6b6;}.f{fill:#e6e6e6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.043)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 27.926,
    cy: 3.436,
    rx: 27.926,
    ry: 3.436,
    transform: "translate(3.956 76.658)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M487.014,176.58H439.662l-.036-.043a6.651,6.651,0,0,1,0-8.516l.036-.043h47.352l-.234.252a5.958,5.958,0,0,0,.192,8.309Z",
    transform: "translate(-438.084 -167.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M410.788,232.086h43.235V173.079a4.986,4.986,0,0,0-4.986-4.986h-42.3s-4.39-.261-4.3,0c3.08.06,2.922,8.6,2.922,8.6v49.963A5.428,5.428,0,0,0,410.788,232.086Z",
    transform: "translate(-399.781 -167.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M364.661,549.022h47.352l.036-.043a6.652,6.652,0,0,0,0-8.516l-.036-.043H364.661l.234.252c2.2,2.365,2.57,6.4-.234,8.35Z",
    transform: "translate(-353.591 -484.913)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 29.417,
    height: 2.475,
    transform: "translate(14.307 9.658)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13.153,
    height: 0.807,
    transform: "translate(10.213 51.721)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 37.604,
    height: 1.006,
    transform: "translate(10.213 16.784)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 37.604,
    height: 1.006,
    transform: "translate(10.213 21.721)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 37.604,
    height: 1.006,
    transform: "translate(10.213 26.657)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 37.604,
    height: 1.006,
    transform: "translate(10.213 31.594)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 37.604,
    height: 1.006,
    transform: "translate(10.213 36.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 37.604,
    height: 1.006,
    transform: "translate(10.213 46.403)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 37.604,
    height: 1.006,
    transform: "translate(10.213 41.467)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 4.151,
    height: 2.475,
    transform: "translate(39.572 9.658)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.1a62bc151389624539d2a8cbba1da84b.svg";
export { ForwardRef as ReactComponent };